module.exports = __webpack_public_path__ + "img/img_01.7154f1ba.jpg";